import { Filters, Study, VoteDecision } from '../StudyList';

export const getVoteState = (
  study: Study,
  currentDecisions: VoteDecision[]
): { currentVote: VoteDecision; currentFilter: Filters } => {
  const ownVotes = study.votes.filter((v) => v.own_vote);
  // Only votes by the current user, and ordered reverse-chronologically.
  const lastOwnVote = ownVotes.sort((a, b) => b.id - a.id)[0];

  const hasValidCurrentVote =
    lastOwnVote?.vote && currentDecisions.includes(lastOwnVote.vote);
  const currentVote = hasValidCurrentVote ? lastOwnVote.vote : undefined;
  const hasConsensus = study.consensus_required !== '';

  let currentFilter: Filters;
  if (hasConsensus) {
    currentFilter = 'resolveConflicts';
  } else if (currentVote) {
    currentFilter = 'awaitingOtherReviewer';
  } else {
    currentFilter = 'screening';
  }

  return { currentVote, currentFilter };
};
